import { fromJS } from 'immutable';
import deepMerge from '../utils/deepMerge';
import { ACTION_PREFIX, BUNDLE_TYPES } from '../constants/packagesConstants';

export const SET_BUNDLE_TYPE = `${ACTION_PREFIX}/SET_BUNDLE_TYPE`;
export const SET_FLIGHT_CLASS = `${ACTION_PREFIX}/SET_FLIGHT_CLASS`;
export const SET_AIRLINE = `${ACTION_PREFIX}/SET_AIRLINE`;
export const SET_NON_STOP = `${ACTION_PREFIX}/SET_NON_STOP`;
export const SET_PARTIAL_ROOM_STAY = `${ACTION_PREFIX}/SET_PARTIAL_ROOM_STAY`;
export const SET_PARTIAL_DATES = `${ACTION_PREFIX}/SET_PARTIAL_DATES`;
export const SET_FILTERS = `${ACTION_PREFIX}/SET_FILTERS`;
export const SET_IS_DRIVERS_AGE_WITHIN_RANGE = `${ACTION_PREFIX}/SET_IS_DRIVERS_AGE_WITHIN_RANGE`;
export const SET_DRIVERS_AGE = `${ACTION_PREFIX}/SET_DRIVERS_AGE`;

export const setFiltersAction = (filters) => ({
  type: SET_FILTERS,
  filters,
});

export const setBundleTypeAction = (bundleType) => ({
  type: SET_BUNDLE_TYPE,
  bundleType,
});

export const setFlightClassAction = (flightClass) => ({
  type: SET_FLIGHT_CLASS,
  flightClass,
});

export const setAirlineAction = (airline) => ({
  type: SET_AIRLINE,
  airline,
});

export const setNonStopAction = (isNonStop) => ({
  type: SET_NON_STOP,
  isNonStop,
});

export const setPartialRoomStayAction = (isPartialRoomStay) => ({
  type: SET_PARTIAL_ROOM_STAY,
  isPartialRoomStay,
});

export const setPartialDatesAction = ({ startDate, endDate }) => ({
  type: SET_PARTIAL_DATES,
  startDate,
  endDate,
});

export const setIsDriversAgeWithinRangeAction = (isDriversAgeWithinRange) => ({
  type: SET_IS_DRIVERS_AGE_WITHIN_RANGE,
  isDriversAgeWithinRange,
});

export const setDriversAgeAction = (driversAge) => ({
  type: SET_DRIVERS_AGE,
  driversAge,
});

export const DEFAULT_FILTER_STATE = fromJS({
  bundleType: BUNDLE_TYPES.AIR_HOTEL,
  airline: null,
  isNonStop: false,
  isPartialRoomStay: false,
  partialRoomStartDate: null,
  partialRoomEndDate: null,
  isDriversAgeWithinRange: false,
  driversAge: '',
});

// eslint-disable-next-line default-param-last -- other order causes render issues
const filtersReducer = (state = DEFAULT_FILTER_STATE, action) => {
  switch (action && action.type) {
    case SET_FILTERS: {
      return fromJS(deepMerge(state.toJS(), action.filters));
    }
    case SET_BUNDLE_TYPE: {
      return state.set('bundleType', action.bundleType);
    }
    case SET_FLIGHT_CLASS: {
      return state.set('flightClass', action.flightClass);
    }
    case SET_AIRLINE: {
      return state.set('airline', action.airline);
    }
    case SET_NON_STOP: {
      const { isNonStop } = action;
      return state.set('isNonStop', isNonStop);
    }
    case SET_PARTIAL_ROOM_STAY: {
      const { isPartialRoomStay } = action;
      return state.set('isPartialRoomStay', isPartialRoomStay);
    }
    case SET_PARTIAL_DATES: {
      const { startDate, endDate } = action;
      const updatedState = state.set('partialRoomStartDate', startDate);
      return updatedState.set('partialRoomEndDate', endDate);
    }
    case SET_IS_DRIVERS_AGE_WITHIN_RANGE: {
      const { isDriversAgeWithinRange } = action;
      return state.set('isDriversAgeWithinRange', isDriversAgeWithinRange);
    }
    case SET_DRIVERS_AGE: {
      const { driversAge } = action;
      return state.set('driversAge', driversAge);
    }
    default:
      return state;
  }
};

export default filtersReducer;
